import styled from 'styled-components';
import {LocalDocumentCategory} from "../../../models/local-documents.models";
import {tokens} from "../../../theme";
import {semanticColors, SemanticColorValue} from "../../../theme/tokens/tokens";

export const documentTypeVariant: Record<LocalDocumentCategory, SemanticColorValue> = {
    MEDICAL_HISTORY: semanticColors.purple.dark,
    REFERRAL:        semanticColors.blue.light,
    TEST_RESULTS:    semanticColors.orange.light,
    STATEMENT:       semanticColors.green.light,
    OTHER:           semanticColors.gray.light,
    UNRECOGNIZED:    semanticColors.gray.dark,
    NOTYPE:          semanticColors.gray.light,
};

// VALID_TYPES = ['NOTYPE', 'MEDICAL_HISTORY', 'TEST_RESULTS', 'REFERRAL', 'STATEMENT', 'OTHER'];
export const StyledDocumentTypeText = styled.span<{ $type: LocalDocumentCategory }>`
    font-size: ${({theme}) => theme.typography.body2.fontSize};
    font-weight: ${tokens.fontWeight.medium};
    white-space: nowrap;
    padding: 4px 8px;
    border-radius: ${tokens.radius.lg};

    color: ${({ $type }) => documentTypeVariant[$type].fg};
    background: ${({ $type }) => documentTypeVariant[$type].bg};
`;

export const StyledNoTypePill = styled.span`
    display: inline-flex;
    align-items: center;
    font-size: ${({theme}) => theme.typography.body2.fontSize};
    font-weight: ${tokens.fontWeight.medium};
    color: ${documentTypeVariant.NOTYPE.fg};
    background: ${documentTypeVariant.NOTYPE.bg};
    border: 1px solid #E2E8F0;
    border-radius: ${tokens.radius.xs};
    padding: 2px 8px;
    white-space: nowrap;
`;